import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ReadingView from '../views/ReadingView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Reading',
    component: ReadingView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
